import {
  CcfHomeIcon,
  CcfCustomerCardIcon,
  CcfAssignementBoxIcon,
  CcfCalendarIcon,
  CcfConversationOutlineIcon,
  CcfDirectoryIcon,
  CcfQueueIcon,
  CcfSettingsIcon,
  CcfWemIcon,
  CcfWorkHistoryIcon,
  CcfQuickRepliesIcon,
  CcfDashboardIcon,
  CcfEnlightenIcon,
  CcfSentimentIcon,
  CcfCustomWorkspaceIcon,
  CcfInteractionSearchIcon,
  CcfIlluminateStarIcon,
} from '@nice-ccf/ui-controls';

export interface CcfMenuIconRendererProps {
  menuName: string;
  htmlColor: string;
}

/**
 * Used to swtich menus
 * @param menuName - string
 * @example - iconRenderer
 */
const iconRenderer = (menuName: string, htmlColor: string) => {
  switch (menuName.toLowerCase()) {
    case 'home':
      return <CcfHomeIcon htmlColor={htmlColor} viewBox="-2 -4 24 24" />;
    case 'assignment':
      return (
        <CcfAssignementBoxIcon
          bgColor="#444d57"
          style={{ fill: '#fff' }}
          viewBox="-2 -4 24 24"
        />
      );
    case 'reports':
      return (
        <CcfDashboardIcon
          htmlColor={htmlColor}
          viewBox="0 -4 32 22"
          style={{ fill: '#444d57', stroke: '#fff' }}
        />
      );
    case 'customercard':
      return <CcfCustomerCardIcon viewBox="-2 -4 24 24" />;
    case 'interactionsearch':
      return <CcfInteractionSearchIcon fillColor={'#fff'} />;
    case 'quickreply':
      return <CcfQuickRepliesIcon />;
    case 'calender':
      return (
        <CcfCalendarIcon
          bgColor="#444d57"
          style={{ fill: '#fff' }}
          viewBox="-2 -4 24 24"
        />
      );
    case 'schedule':
      return (
        <CcfCalendarIcon
          bgColor="#444d57"
          style={{ fill: '#fff' }}
          viewBox="-2 -4 24 24"
        />
      );
    case 'directory':
      return (
        <CcfDirectoryIcon
          bgColor="#444d57"
          style={{ fill: '#fff' }}
          viewBox="-2 -4 24 24"
        />
      );
    case 'queue':
      return <CcfQueueIcon style={{ fill: '#444d57' }} viewBox="-2 -6 24 24" />;
    case 'wem':
      return <CcfWemIcon style={{ fill: '#fff' }} viewBox="-2 -4 24 24" />;
    case 'enlighten':
      return <CcfEnlightenIcon viewBox="-2 -4 24 24" />;
    case 'sentiment':
      return <CcfSentimentIcon viewBox="-2 -4 24 24" />;
    case 'contacthistory':
      return (
        <CcfWorkHistoryIcon
          htmlColor={htmlColor}
          viewBox="-2 -4 24 24"
          bgColor="#606870"
          style={{ fill: '#fff' }}
        />
      );
    case 'contact history':
      return (
        <CcfWorkHistoryIcon
          htmlColor={htmlColor}
          viewBox="-2 -4 24 24"
          bgColor="#606870"
          style={{ fill: '#fff' }}
        />
      );
    case 'copilot':
      return (
        <CcfIlluminateStarIcon
          htmlColor={htmlColor}
          viewBox="0 -4 32 32"
          style={{ fill: '#444d57', stroke: '#fff' }}
        />
      );
    case 'settings':
      return <CcfSettingsIcon htmlColor={htmlColor} viewBox="-2 -4 24 24" />;
    case 'customworkspace':
      return (
        <CcfCustomWorkspaceIcon htmlColor={htmlColor} viewBox="-2 -4 24 24" />
      );
    default:
      return null;
  }
};

/**
 * Used to render the translated tooltip for menu
 * @param menuName - string
 * @example CcfMenuIconRenderer
 */
const CcfMenuIconRenderer = (props: CcfMenuIconRendererProps) => {
  return iconRenderer(props.menuName, props.htmlColor);
};
export default CcfMenuIconRenderer;
